<template>
    <div>
        <v-card class="">
            <person-employments-table :person-id="personId" />
        </v-card>
    </div>
</template>

<script>
    import PersonEmploymentsTable from './PersonEmploymentsTable';

    export default {

        name: "Employment",

        components: {
            PersonEmploymentsTable,
        },

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },
    }
</script>

<style scoped>
</style>
